import { ProductLayoutType } from '@linktivity/ars-neo';
import { useBookingStore } from '../context';
import { PlanCards } from './PlanCards';
import { PlanSteps } from './PlanSteps';

interface Props {
  onLoadMore: () => void;
}

/**
 * The plans, in the layout the product is configured with.
 *
 * Rendered on the server too: what comes from the product — plan names,
 * pictures, starting prices — is in the HTML, and what needs the calendar
 * shows as skeletons until the browser has loaded it.
 */
export function ProductPlans({ onLoadMore }: Props) {
  const store = useBookingStore();
  return store.product.layout?.layoutType ===
    ProductLayoutType.ProductLayoutTypeColumn ? (
    <PlanSteps onLoadMore={onLoadMore} />
  ) : (
    <PlanCards onLoadMore={onLoadMore} />
  );
}
